import {
    DateHeaderCellProps,
    TimeHeaderCell,
    TimeHeaderCellProps,
} from '@progress/kendo-react-scheduler'
import { AuthContext, useAuth } from 'context/AuthContext'
import { useTenantContext } from 'context/TenantContext'
import { classNames } from 'utils/dom-helpers'
import { createModal } from '../ModalFactory'
import { ModalWrapper } from '../ModalWrapper'

const ModalProvider = createModal(
    AuthContext,
    'HtmlPreviewModal',
    () => <></>,
    () => <></>
)

function DateCell(p: DateHeaderCellProps) {
    return (
        <div
            {...p}
            className={classNames(
                p.className || '',
                'border-l-white border-r-white px-1'
            )}
        >
            <div className="text-left w-full">
                <div className="block font-thin border-b border-gray-300 text-xs py-2">
                    {p.date.toLocaleDateString('default', {
                        weekday: 'long',
                    })}
                </div>
                <strong className="text-xl border-t-1 mt-2">
                    {p.date.toLocaleDateString('default', {
                        day: '2-digit',
                    })}
                </strong>
            </div>
        </div>
    )
}

function TimeCell(p: TimeHeaderCellProps) {
    return <TimeHeaderCell {...p} format="ha" />
}

export function Embedable() {
    const { attributes, setAttributes, HtmlPreviewModal: Ctx } = useAuth()
    const { tenant } = useTenantContext()

    return (
        <ModalProvider.Visible>
            <ModalWrapper className="w-wide">
                <div
                    className="bg-white shadow-2xl overflow-y-auto overflow-x-hidden sm:rounded-md relative"
                    style={{ minHeight: '680px' }}
                >
                    <button
                        type="button"
                        className="absolute right-2 top-2 text-3xl font-thin"
                        onClick={() => {
                            Ctx.close()
                        }}
                    >
                        <i className="feather-x" />
                    </button>
                    <iframe
                        src={`/calendar/?t=${tenant?.id}&loc=${attributes.location_id}`}
                        style={{ height: '100%', width: '100%' }}
                        loading="lazy"
                    />
                </div>
            </ModalWrapper>
        </ModalProvider.Visible>
    )
}

export default Embedable
